import { type HandleSubmitMessageType } from '@/utils/aiUtils';
import { SupportedRegion } from '@ditto/shared';
import { type FC } from 'react';
import { EU, US } from 'country-flag-icons/string/3x2';
import flagWorld from '@/assets/flag-world.svg';

const toDataUrl = (svg: string) =>
  `data:image/svg+xml,${encodeURIComponent(svg)}`;

export interface RegionBadgesProps {
  onSelect: (region: SupportedRegion) => void;
  onSendMessage?: (message: HandleSubmitMessageType) => void;
}

export const RegionBadges: FC<RegionBadgesProps> = ({
  onSelect,
  onSendMessage,
}) => {
  const regions: Array<{
    value: SupportedRegion;
    flagImage: string;
    label: string;
  }> = [
    {
      value: 'US',
      flagImage: toDataUrl(US),
      label: 'United States',
    },
    {
      value: 'EU',
      flagImage: toDataUrl(EU),
      label: 'European Union',
    },
    {
      value: 'WORLD',
      flagImage: flagWorld,
      label: 'Global',
    },
  ];

  return (
    <div className="flex items-center gap-2 px-1 py-2">
      <span className="text-sm text-muted-foreground">
        {'Suggested regulatory regions'}:
      </span>
      {regions.map(region => (
        <button
          key={region.value}
          type="button"
          className="inline-flex items-center gap-[6px] px-[8px] py-[3px] rounded-[8px] text-[12px] font-medium text-[#171717] tracking-[0.18px] bg-[#FAFAFA] border border-solid border-[#E5E5E5] hover:bg-neutral-100 transition-colors cursor-pointer"
          onClick={() => {
            onSelect(region.value);
            // Send message with region metadata
            if (onSendMessage) {
              onSendMessage({
                text: region.label,
                metadata: { region: region.value },
              });
            }
          }}
        >
          <img
            src={region.flagImage}
            alt=""
            className="w-[16px] h-[16px] object-contain"
          />
          <span>{region.label}</span>
        </button>
      ))}
    </div>
  );
};
